import React, { useState, useRef, useEffect } from "react";
import * as Mui from "@mui/material";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { CustomButton,InfoMessage} from "components/CustomComponents/CustomButton";
import { EPFReportKeys } from "pages/PayRoll/PayRollHeaders";

export const EPFReportTable = ({
  PFDetails,
  listViewPage,
  setListViewPage,
  pfReportState
}) => {
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [openDialog, setOpenDialog] = useState(false);
  const containerRef = useRef(null);

  const handleChangePage = (event, newPage) => {
    setListViewPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setListViewPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [listViewPage]);

  return (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{ mt: 2, width: "100%", ml: 2, mr: 2, maxHeight: 720 }}
        >
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow
                sx={{
                  "& .MuiTableCell-root": {
                    height: "10px",
                    padding: "3px 15px",
                  },
                }}
              >
                {EPFReportKeys.map((header) => (
                  <Mui.TableCell
                    sx={{ color: themes.headLine, fontWeight: "bold" }}
                  >
                    {header.name}
                  </Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {PFDetails?.length === 0 ? (
             <InfoMessage dataLength={pfReportState} />
              ) : (
                PFDetails?.slice(
                  listViewPage * rowsPerPage,
                  listViewPage * rowsPerPage + rowsPerPage
                ).map((salary) => (
                  <Mui.TableRow
                    sx={{
                      "& .MuiTableCell-root": {
                        height: "10px",
                        padding: "3px 15px",
                      },
                    }}
                  >
                    {EPFReportKeys.map((header) => (
                      <Mui.TableCell sx={{ color: themes.headLine }}>
                        {header.key === "user_name" ? (
                          <Mui.Stack direction="Row">
                            <Mui.Avatar
                              sx={{
                                width: 23,
                                height: 23,
                              }}
                              alt={salary?.user_name?.charAt(0).toUpperCase()}
                              src={salary?.image_url ?? optionalAvathar}
                            />
                            &nbsp;
                            {salary?.user_name}
                          </Mui.Stack>
                        ) : salary[header.key] || salary[header.key] === 0 ? (
                          salary[header.key]
                        ) : (
                          "N/A"
                        )}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>

      {PFDetails?.length > 25 && (
        <Mui.TablePagination
          className="custom-pagination"
          component="div"
          rowsPerPageOptions={[25, 50, 75, 100]}
          count={PFDetails?.length}
          rowsPerPage={rowsPerPage}
          page={listViewPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
      <GlobalDialogBox
        handleCloseDialog={() => {
          setOpenDialog(false);
        }}
        open={openDialog}
        title="Delete payrun period"
      >
        <Mui.Grid container>
          <Mui.Typography sx={{ paddingBottom: 2 }}>
            Are you sure,you want to delete the ?
          </Mui.Typography>
          <Mui.Grid
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <CustomButton
              actionFuntion={() => {
                setOpenDialog(false);
              }}
              actionName="No"
              typeName="button"
            />
            &nbsp;&nbsp;
            <CustomButton actionName="Yes" typeName="button" />
          </Mui.Grid>
        </Mui.Grid>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
